/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
// import * as moment from 'moment';

// moment.locale('en-gb');
if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));


// function fetchConfig() {
//   return fetch('/assets/config/config.json')
//     .then(response => response.json())
//     .then(config => {
//       environment.api.core.base = config.apiUrl;
//     });
// }

// fetchConfig().then(() => {
//   if (environment.production) {
//     enableProdMode();
//   }
//   platformBrowserDynamic().bootstrapModule(AppModule)
//     .catch(err => console.error(err));
// });